import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowLeft, ExternalLink } from "lucide-react";
import { usePageMeta } from "../hooks/usePageMeta";

// =============================================================
// Partenaires Page Content — reuses the modal's exact layout
// =============================================================
export const PartenairesContent = () => {
  usePageMeta({
    title: "Nos Partenaires — Brice Médium",
    description:
      "Découvrez nos partenaires de confiance, professionnels reconnus partageant nos valeurs d'authenticité, de bienveillance et de respect.",
    url: "https://bricemedium.fr/partenaires",
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div className="bg-dark-bg text-cream min-h-screen">
      {/* Hero band */}
      <section className="relative pt-32 pb-10 md:pt-40 md:pb-14 px-4 sm:px-6 overflow-hidden">
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full pointer-events-none"
          style={{
            background:
              "radial-gradient(circle, rgba(201,169,110,0.07) 0%, transparent 70%)",
          }}
        />
        <div className="relative max-w-3xl mx-auto text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 mb-6 text-sm text-cream/60 hover:text-sepia transition-colors font-lato tracking-wider uppercase"
            data-testid="back-home-link"
          >
            <ArrowLeft size={14} />
            Retour à l'accueil
          </Link>
          <h1 className="font-playfair text-3xl sm:text-4xl md:text-5xl text-cream mb-4 font-light">
            Nos <em className="text-sepia italic">Partenaires</em>
          </h1>
          <div className="flex justify-center mb-6">
            <div className="w-32 h-px bg-gradient-to-r from-transparent via-sepia to-transparent" />
          </div>
          <p className="font-cormorant text-lg md:text-xl text-cream/80 leading-relaxed max-w-2xl mx-auto">
            Nous collaborons avec des professionnels de confiance qui partagent
            nos valeurs d'authenticité, de bienveillance et de respect.
          </p>
        </div>
      </section>

      {/* Partner cards */}
      <section className="px-4 sm:px-6 pb-16">
        <div className="max-w-3xl mx-auto space-y-6">
          {/* Partner Card — J'aime la Voyance */}
          <div
            className="bg-dark-card border border-gold-muted/30 p-6 md:p-8 hover:border-sepia/50 transition-colors"
            data-testid="partner-card-jaimelavoyance"
          >
            <div className="flex flex-col items-center text-center">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-sepia/20 to-gold-muted/20 border-2 border-sepia flex items-center justify-center mb-4">
                <Sparkles size={32} className="text-sepia" />
              </div>

              <h2 className="font-playfair text-xl md:text-2xl text-sepia mb-2">
                J'aime la Voyance
              </h2>

              <p className="font-cormorant text-base md:text-lg text-cream/75 mb-5 max-w-md leading-relaxed">
                Plateforme de référence dans le domaine de la voyance, offrant
                des consultations de qualité avec des professionnels expérimentés.
              </p>

              <a
                href="https://www.jaimelavoyance.fr"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-sepia text-dark-bg hover:bg-gold-soft font-playfair tracking-wider py-3 px-6 transition-all hover:-translate-y-0.5 hover:shadow-lg hover:shadow-sepia/20"
                data-testid="partner-link-jaimelavoyance"
              >
                <span>Visiter le site</span>
                <ExternalLink size={16} />
              </a>

              <p className="mt-3 text-sepia/80 text-sm font-lato tracking-wide">
                www.jaimelavoyance.fr
              </p>
            </div>
          </div>

          {/* Become Partner */}
          <div className="pt-8 border-t border-gold-muted/20 text-center">
            <p className="font-cormorant text-base md:text-lg text-cream/70">
              Vous souhaitez devenir partenaire ?
            </p>
            <p className="font-cormorant text-base md:text-lg text-cream/70 mt-1">
              Contactez-nous à{" "}
              <a
                href="mailto:contact@bricemedium.fr"
                className="text-sepia hover:underline"
              >
                contact@bricemedium.fr
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};
